import { render, staticRenderFns } from "./GetTrustScore.vue?vue&type=template&id=37ecb646&scoped=true&"
import script from "./GetTrustScore.vue?vue&type=script&lang=js&"
export * from "./GetTrustScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecb646",
  null
  
)

export default component.exports